import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import { CUSTOM_DESKTOP_UA } from 'constants/common';
import { getHostname } from 'actions/PaymentActions/utils/hostname';
const webClient = ExecutionEnvironment.canUseDOM;
const ua = typeof navigator !== 'undefined' ? navigator.userAgent : 'StandardUA';
export const xUserAgent = `${ua} ${CUSTOM_DESKTOP_UA}`;
export const headers = {
    'X-User-Agent': xUserAgent,
    'Content-Type': 'application/json'
};
if (!webClient) {
    Object.assign(headers, {
        compress: true,
        Connection: 'keep-alive',
        'Keep-Alive': 'timeout=600'
    });
}
const protocol = webClient ? 'https' : 'http';
const baseConfig = Object.assign({}, { headers }, {
    protocol,
    hostname: __API_HOST__ || 'www.flipkart.com',
    credentials: 'include',
    fk_api_timeout: webClient ? 30000 : 6000
});
export default baseConfig;
/* ===========================================
---- ---- Payment api configuration ---- ----
============================================ */
export const paymentHeaders = Object.assign({}, headers, {
    'x-device-source': 'web'
});
export const paymentAjaxConfig = Object.assign({}, baseConfig, {
    headers: paymentHeaders,
    hostname: __PAYMENT_API_HOST__ || getHostname()
});
export const savedCardsAjaxConfig = Object.assign({}, paymentAjaxConfig, {
    hostname: __PAYMENT_API_HOST__ || 'payments.flipkart.com/fkpay/v1/account/'
});
